import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import { toast } from 'react-toastify';
import { startFormLoading, stopFormLoading } from './loader';

const fetchAllItemTypesDone = payload => ({
    type: TYPES.FETCH_ALL_ITEM_TYPES_DONE,
    payload,
  });
export const fetchAllItemTypes = () => dispatch =>{
    return client.getAllItemTypes().then(
      response=>{
        if(response.ok || response.status === 200){
           return response.json().then(responsejson => {
               let itemTypeOptions = responsejson.map(itemType => ({ value: itemType.id, label: itemType.name }))
               dispatch(fetchAllItemTypesDone(itemTypeOptions))
            })
        } else {
          // alert('Something went wrong with fetching all item types')
        }
      }
    )
  }

const getAllUserTypeRolesDone = payload => ({
    type:TYPES.GET_ALL_USER_TYPE_ROLES,
    payload
})
  export const getAllUserTypeRoles = () => dispatch =>{
    return client.getAllRoles().then(
      response => {
        if(response.ok || response.status === 200){
           return response.json().then( responsejson => {
            dispatch(getAllUserTypeRolesDone(responsejson))
           })
        }else{
          // alert('Something went wrong with fetching roles')
        }
      }
    )
  }

  const fetchAllIssueTypesDone = payload => {
    return {
      type: TYPES.FETCH_ALL_ISSUE_TYPES,
      payload
    };
  }

  const fetchAllTicketStatusDone = payload => {
    return {
      type: TYPES.FETCH_ALL_TICKET_STATUS,
      payload
    };
  }


  export const fetchAllIssueTypes = () => dispatch =>{
    return client.getIssueTypes().then(
      response => {
        if( response.ok || response.status === 200){
          response.json().then(
            responsejson => {
              // alert('fetched')
        
             dispatch( fetchAllIssueTypesDone(responsejson))
            }
          )
        } else {
          // alert('Something went wrong with fetching issue types')
        }
      }
    )
  }
  export const fetchAllTicketStatus = (type) => dispatch =>{
    return client.getTicketStatus().then(
      response => {
        if( response.ok || response.status === 200){
          response.json().then(
            responsejson => {     
             dispatch( fetchAllTicketStatusDone(responsejson))
            }
          )
        } else {
          // alert('Something went wrong with fetching issue types')
        }
      }
    ).catch(() => {
      // alert('Something went wrong with fetching issue types')
    })
  }

  const fetchPropertyStagesDone = payload => {
    return {
      type: TYPES.FETCH_PROPERTY_STAGES,
      payload
    };
  }

  export const fetchPropertyStages = () => dispatch => {
    return client.getPropertyStages().then(response => {
      if(response.ok || response.status === 200) {
        response.json().then(responsejson => {
          dispatch(fetchPropertyStagesDone(responsejson))
        })
      } 
    })
  }
  const fetchPropertyStatusesDone = payload => {
    return {
      type: TYPES.FETCH_PROPERTY_STATUSES,
      payload
    };
  }

  export const fetchPropertyStatuses = () => dispatch => {
    return client.getPropertyStatuses().then(response => {
      if(response.ok || response.status === 200) {
        response.json().then(responsejson => {
          dispatch(fetchPropertyStatusesDone(responsejson))
        })
      } 
    })
  }

  export const setBuildVersion = (payload) => {
    return {
      type: TYPES.SET_BUILD_VERSION,
      payload
    };
  }
  
  export const fetchServiceRequestTags = () => dispatch => {
    // dispatch(startFormLoading());
    return client.getServiceRequestTags().then(response => {
      dispatch(stopFormLoading())
      if(response.ok || response.status === 200) {
        response.json().then(responsejson => {
          dispatch(fetchServiceRequestTagsDone(responsejson))
        })
      } else {
        dispatch(fetchServiceRequestTagsDone([]))
      }
    }).catch(() => {
      // dispatch(stopFormLoading());
      dispatch(fetchServiceRequestTagsDone([]))
    })
  }

  export const fetchServiceRequestTagsDone = (payload) => {
    return {
      type: TYPES.FETCH_SERVICE_REQUEST_TAGS_DONE,
      payload
    };
  }